module.exports = __webpack_public_path__ + "static/img/emergency_shelter.3c291ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataset/emergency_shelter.png
// module id = gLb5
// module chunks = 1